import { routes } from "@/constants/routes";
import { useTheme } from "@/theme/ThemeProvider";
import { AppButton } from "@/ui/components/AppButton";
import { CaseTableWorkspace } from "@/ui/components/caseTable/CaseTableWorkspace";
import { Screen } from "@/ui/components/Screen";
import { useRouter } from "expo-router";
import { View } from "react-native";

/**
 * Kompakte Tierliste – Desktop als Arbeitsansicht, Filter oben, dichte Zeilen.
 */
export default function AnimalsIndexScreen() {
  const { theme } = useTheme();
  const router = useRouter();

  return (
    <Screen
      title="Tiere"
      scroll
      contentStyle={{ paddingBottom: theme.space.xxl }}
    >
      <View style={{ gap: theme.space.md }}>
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            gap: theme.space.sm,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <View style={{ flexDirection: "row", flexWrap: "wrap", gap: theme.space.xs }}>
            <AppButton onPress={() => router.push(routes.myAnimalNew as never)}>
              Tier aufnehmen
            </AppButton>
            <AppButton
              variant="outline"
              onPress={() => router.push(routes.myAnimalBatch as never)}
            >
              Mehrere aufnehmen
            </AppButton>
          </View>
        </View>
        <CaseTableWorkspace />
      </View>
    </Screen>
  );
}
